// src/components/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Navbar.css';

function Navbar() {
  return (
    <nav className="Navbar">
      <div className="nav-right">
        <Link to="/">
          <img src="/img/moa4cutsKR.png" alt="Logo" className="logo" />
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;